/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon24Regular = forwardRef('DivideIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 6.374a1.374 1.374 0 1 0 0-2.748 1.374 1.374 0 0 0 0 2.748Z" }),
        React.createElement("path", { d: "M3.25 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M13.374 19a1.374 1.374 0 1 1-2.748 0 1.374 1.374 0 0 1 2.748 0Z" })));
});
